module.exports = __webpack_public_path__ + "static/media/10_720.20429cdd.jpeg";